import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import type { IBrazilianRealEstateFundTopLevelFragment } from "lib/fragments/__generated__/BrazilianRealEstateFundTopLevel.generated";

interface ICompanyIssuerExternalLinksProps {
  issuer:
    | IBrazilianCompanyIssuerTopLevelFragment
    | IBrazilianRealEstateFundTopLevelFragment
    | IAmericanCompanyIssuerTopLevelFragment;
}

export default function CompanyIssuerExternalLinks({ issuer }: ICompanyIssuerExternalLinksProps) {
  const isBrazilianIssuer = issuer.__typename === "BrazilianCompanyIssuer";
  const isBrazilianRealEstateFundIssuer = issuer.__typename === "BrazilianRealEstateFund";
  const isAmericanIssuer = issuer.__typename === "AmericanCompanyIssuer";

  const websiteHref = isAmericanIssuer ? issuer.websiteHref : issuer.website;
  const investorRelationsHref = getInvestorRelationsHref(issuer);
  return (
    <div className="flex h-10 items-center divide-x divide-slate-100">
      {investorRelationsHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="p-3 text-sm font-bold text-blue-600 no-underline hover:underline"
          href={investorRelationsHref}
        >
          {isAmericanIssuer && "Investor Relations"}
          {isBrazilianIssuer && "Site de RI"}
          {isBrazilianRealEstateFundIssuer && "Site do Fundo"}
        </a>
      )}

      {!investorRelationsHref && websiteHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={investorRelationsHref}
          className="p-3 text-sm font-bold text-blue-600 no-underline hover:underline"
        >
          <span>Website</span>
        </a>
      )}

      {isBrazilianIssuer && issuer.cvmCode && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://sistemaswebb3-listados.b3.com.br/listedCompaniesPage/main/${issuer.cvmCode}/${issuer.tickerSymbolPrefix}/overview?language=pt-br`}
          className="p-3 text-sm font-bold text-blue-600 no-underline hover:underline"
        >
          <span>Site B3</span>
        </a>
      )}

      {isBrazilianRealEstateFundIssuer && issuer.fundosNetHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={issuer.fundosNetHref}
          className="p-3 text-sm font-bold text-blue-600 no-underline hover:underline"
        >
          <span>Arquivos</span>
        </a>
      )}

      {isAmericanIssuer && issuer.edgarHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={issuer.edgarHref}
          className="p-3 text-sm font-bold text-blue-600 no-underline hover:underline"
        >
          <span>SEC</span>
        </a>
      )}
    </div>
  );
}

function getInvestorRelationsHref(
  issuer:
    | IBrazilianCompanyIssuerTopLevelFragment
    | IBrazilianRealEstateFundTopLevelFragment
    | IAmericanCompanyIssuerTopLevelFragment,
) {
  if (issuer.__typename === "AmericanCompanyIssuer") {
    return issuer.investorRelationsHref;
  }

  if (issuer.__typename === "BrazilianCompanyIssuer") {
    return issuer.investorRelationsUrl;
  }

  return issuer.website;
}
